'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgEuro(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 14c3.284 0 6-2.709 6-6 0-3.284-2.716-6-6.007-6C4.709 2 2 4.716 2 8c0 3.291 2.716 6 6 6zm.867-3.117c-1.413 0-2.505-.713-2.826-2.031h-.56a.295.295 0 01-.299-.299c0-.182.124-.305.299-.305h.473c-.007-.051-.007-.146-.007-.24V7.76H5.48a.29.29 0 01-.299-.299c0-.175.124-.298.299-.298h.553c.32-1.326 1.413-2.046 2.84-2.046.357 0 .604.05.757.145.197.11.255.255.255.422 0 .226-.131.372-.32.408-.153.051-.416.03-.692.03-.765.014-1.398.363-1.639 1.04h1.799c.182 0 .299.124.299.3a.287.287 0 01-.299.298H7.09c-.007.073-.007.16-.007.247 0 .088.007.182.014.24h1.937c.182 0 .299.124.299.306a.29.29 0 01-.299.299H7.235c.233.677.867 1.027 1.632 1.034.29.007.538-.007.691.036.197.037.335.175.335.4 0 .176-.08.314-.255.416-.16.095-.407.145-.771.145z", fill: "currentColor" }))));
}

module.exports = SvgEuro;
//# sourceMappingURL=Euro.js.map
